module.exports = __webpack_public_path__ + "img/Aptitude-Test.2392cac1.svg";